import { render, staticRenderFns } from "./InformationOwnerTableToolbar.vue?vue&type=template&id=704bfc21"
import script from "./InformationOwnerTableToolbar.vue?vue&type=script&lang=js"
export * from "./InformationOwnerTableToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports